
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import TermsSection from './components/TermsSection';




function Terms() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <TermsSection />
      </main>
      <Footer />
    </div>
  );
}

export default Terms;